import React from "react"
import cx from "classnames"
import { observer } from "mobx-react-lite"
import Tile from "./Tile"
import WORDS from "../WORDS"


const App = observer(function App({appState}) {

    const { rows } = appState

    return (
        <>
            {
                rows.map((row,idx) => (
                    <div key={idx}>
                        <Tile appState={ appState } row={ row } index={ 0 }/>
                        <Tile appState={ appState } row={ row } index={ 1 }/>
                        <Tile appState={ appState } row={ row } index={ 2 }/>
                        <Tile appState={ appState } row={ row } index={ 3 }/>
                        <Tile appState={ appState } row={ row } index={ 4 }/>
                        <button
                            type="button"
                            onClick={ () => row.rate(appState) }
                            >
                            Rate
                        </button>
                    </div>
                ))

            }
            <p className="muted">
                Combined game/solver. "Rate" rates the current row after changes. "Enter" inside an input cycles the rating. Click below to guess
            </p>
            <div id="words">
                {
                    appState.words.map(
                        (s,i) => (
                            <button
                                key={i}
                                type="button"
                                className="w"
                                onClick={ () => appState.choose(s)}
                            >
                                {
                                    s
                                }
                            </button>
                        )
                    )
                }
            </div>
        </>
    )
})

export default App
